import { render, staticRenderFns } from "./Meds.vue?vue&type=template&id=6bbb8644"
import script from "./Meds.vue?vue&type=script&lang=js"
export * from "./Meds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports